/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    RETURNED: 'returned',
    IN_PROGRESS: 'inProgress',
    WAITING: 'waiting',
    NO_REFUNDATION_NEEDED: 'noRefundationNeeded',
    UNBLOCKED: 'unblocked',
    STORNO_100_PERCENT: 'storno100Percent',
    CREDIT_PASS_OUTSIDE_REFUND: 'creditPassOutsideRefund',
};
